import React, { useState } from 'react';
import {
  Box,
  CircularProgress,
  Dialog,
  AppBar,
  Toolbar,
  DialogTitle,
  DialogContent,
  IconButton
} from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
import HistoryIcon from '@mui/icons-material/History';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { WeeklySummary } from 'components/timekeepingHistory';
import { AllShift } from 'components/timekeepingHistory';
import user_api from 'utils/api/users';
import { useSnackbar } from 'notistack5';

const useStyles = makeStyles({
  customWidthHistory: {
    maxWidth: "none",
    height: "80%"
  }
});

const MyHistoryDialog = ({ open, onClose, userId }) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [summaryPage, setSummaryPage] = useState(true);
  const [allShiftPage, setAllShiftPage] = useState(false);

  // Load history data when dialog opens
  React.useEffect(() => {
    if (open && userId) {
      loadHistoryData();
    }
  }, [open, userId]);

  const loadHistoryData = async () => {
    try {
      setIsLoading(true);
      const result = await user_api.get_limited_users(userId);
      if (result && result.data) {
        setUsers(result.data);
      } else {
        enqueueSnackbar("No history records found", { variant: "info" });
      }
    } catch (error) {
      console.error('Error fetching history:', error);
      enqueueSnackbar("Failed to load history. Please try again.", { variant: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSwitchPage = (pageIndex) => {
    if (pageIndex === 0) {
      setSummaryPage(true);
      setAllShiftPage(false);
    } else {
      setSummaryPage(false);
      setAllShiftPage(true);
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="xl" 
      classes={{ paperScrollPaper: classes.customWidthHistory }} 
      disableScrollLock={true}
    >
      <AppBar sx={{ position: "relative", backgroundColor: '#2194F3' }}>
        <DialogTitle sx={{ color: 'white' }}>Time keeping history</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </AppBar>
      <DialogContent>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            {summaryPage && (<WeeklySummary />)}
            {allShiftPage && (<AllShift />)}
          </>
        )}
      </DialogContent>
      <AppBar sx={{ position: "relative", top: "auto", bottom: 0 }}>
        {/* Footer content */}
        <Toolbar sx={{
          padding: '10px',
          backgroundColor: '#2194F3',
          boxShadow: '0px -2px 5px 0px rgba(0, 0, 0, 0.1)',
        }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-around',
              width: '100%'
            }} >
            <Box
              onClick={() => handleSwitchPage(0)}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer'
              }}>
              <HistoryIcon style={{ fontSize: summaryPage ? 45 : 30, color: summaryPage ? 'white' : '#d4d4d4' }} />
              <Typography variant='caption' sx={{ color: summaryPage ? 'white' : '#d4d4d4' }}> Weekly Summary </Typography>
            </Box>
            <Box
              onClick={() => handleSwitchPage(1)}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer'
              }}
            >
              <DateRangeIcon style={{ fontSize: allShiftPage ? 45 : 30, color: allShiftPage ? 'white' : '#d4d4d4' }} />
              <Typography variant="caption" sx={{ color: allShiftPage ? 'white' : '#d4d4d4' }}> All My Shifts </Typography>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
    </Dialog>
  );
};

export default MyHistoryDialog;
